import React, { FC } from 'react';
import { QuestionnaireVm } from './ManageSurveysModal';
import { startOfToday } from 'date-fns';
import { useSurveyIcon } from '../../../../application/hooks/useSurveyIcon';
import Style from './manageSurveys.module.scss';
import { AppButton } from '../../../uikit/buttons/button/button.component';
import { ReactComponent as DeleteIcon } from '../../../../assets/img/common/delete.svg';
import { subTimeUnitFromDate, formatDateRange } from '../../../../helpers/date-helpers';
import { Permissions, StudyRoleClaimValue } from 'src/services/api/api-client';
import { GlobalPermissionsCheck } from '../../../../helpers/components/PermissionCheck/PermissionCheck.component';
import { useHasStudyClaims } from 'src/helpers/auth/auth-helper';

export const Row: FC<{
  questionnaire: QuestionnaireVm;
  onDelete: (questionnaire: QuestionnaireVm) => void;
}> = (props) => {
  const today = startOfToday();
  const { hasStudyClaim } = useHasStudyClaims();
  const { onDelete, questionnaire } = props;
  const canBeDeleted = questionnaire.start > today && questionnaire.id !== null && questionnaire.triggeredByDoctor;

  const surveyIcon = useSurveyIcon(questionnaire.surveyIcon, 'small', 'filled');

  const formattedPeriod = formatDateRange(questionnaire.start, subTimeUnitFromDate(questionnaire.end, 'days'));

  return (
    <div className={Style.row}>
      <div className={Style.typeColumn}>
        <surveyIcon.SvgIcon />
        <span>{questionnaire.surveyType}</span>
      </div>
      <div>{formattedPeriod}</div>
      {canBeDeleted && hasStudyClaim(StudyRoleClaimValue.PatientCreate) && (
        <AppButton
          className={Style.actionsColumn}
          variant={'icon-link'}
          colorSchema={'decline'}
          Icon={DeleteIcon}
          onClick={() => onDelete(questionnaire)}
        />
      )}
    </div>
  );
};
